export default __webpack_public_path__ + "static/media/home.86a43062.svg";